import React, { useEffect } from "react";
import {useDispatch, useSelector} from "react-redux";
import { Box } from "@mui/material";
import { labelTypeActions } from "../../../../../../actions";
import DataTable from "../../../../../common/ui/table/DataTable/DataTable.component";

const LabelType = () => {
  const dispatch = useDispatch();
  const  labels  = useSelector((state) => state.labels);

  const columns = [
    { field: "id", headerName: "ID", width: 70 },
    {
      field: "name",
      headerName: "Label Name",
      minWidth: 200,
      flex: 1,
    }
  ];

  const recordIdentifier = "labelname";

  useEffect(() => {
    dispatch(labelTypeActions.getAllParameters());
  }, [dispatch]);

  return (
    <Box>

        <DataTable
          loading={labels?.loading}
          rows={labels?.items?.data}
          columns={columns}
          recordIdentifier={recordIdentifier}
          actionIdentifier="labelActions"
          recordType={"label"}
        />

    </Box>
  );
};

export default LabelType;
